import { FormattedAmount } from 'components/FormattedAmount/FormattedAmount';
import { ErrorComponent } from 'components/ui/Error/Error';
import { Heading } from 'components/ui/Heading/Heading';
import PropTypes from 'prop-types';
import { useTranslations } from 'utils/translations/useTranslations';

export function NoOptionsError({ purchase = {}, recipientName }) {
  const i18n = useTranslations();
  return (
    <ErrorComponent>
      <Heading
        as="h1"
        size="large"
        className="textAlign-center marginBotom-sm fontWeight-semiBold marginBottom-sm"
      >
        {i18n.t('checkout.error.title')}
      </Heading>
      <p className="type-regular paddingH-xxl">
        {i18n.t('checkout.paymentOptions.none.error', {
          recipientName,
          amount: <FormattedAmount {...purchase} />,
        })}
      </p>
    </ErrorComponent>
  );
}

NoOptionsError.displayName = 'NoOptionsError';
NoOptionsError.propTypes = {
  purchase: PropTypes.shape({
    currency: PropTypes.string,
    value: PropTypes.number,
  }).isRequired,
  recipientName: PropTypes.string.isRequired,
};
